import { Typography } from '@material-ui/core';
import React, { FC } from 'react';

const LegalInfo: FC = () => (
  <Typography align="center" variant="body2" gutterBottom>
    Code Savvy is a not-for-profit organization with 501(c)3 status from the IRS. Code Savvy's EIN
    is 46-3760347
  </Typography>
);

export default LegalInfo;
